import React from 'react';

export const FamilyParentsSummary = ({ parents }) => {
  const entries = [['mother', 'Mãe'], ['father', 'Pai']].filter(([slot]) => parents?.[slot]?.responsible_id);
  if (!entries.length) return null;
  return <section className="border-y border-emerald-200 py-3" data-testid="smart-import-family-parents">
    <h3 className="text-xs font-semibold text-emerald-800 mb-2" data-testid="smart-import-family-parents-heading">Mãe e pai · dados já cadastrados</h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {entries.map(([slot, label]) => <div key={slot} className="min-w-0 text-xs space-y-1" data-testid={`smart-import-family-parent-${slot}`}>
        <p className="font-semibold break-words" data-testid={`smart-import-family-parent-${slot}-name`}>{label} · {parents[slot].name || 'Nome não informado'}</p>
        {parents[slot].email && <p className="text-slate-600 break-words" data-testid={`smart-import-family-parent-${slot}-email`}>{parents[slot].email}</p>}
        {parents[slot].cellphone && <p className="text-slate-600" data-testid={`smart-import-family-parent-${slot}-phone`}>{parents[slot].cellphone}</p>}
      </div>)}
    </div>
  </section>;
};